$(function () {
  $(".dropdown-hover-js").on("click", function () {
    $(this).next("ul").slideToggle("medium");
    if ($(this).attr("aria-expanded") == "false") {
      $(this).attr("aria-expanded", "true");
    } else {
      $(this).attr("aria-expanded", "false");
    }
  });

  $("body").on("click", function (e) {
    if ($(".dropdown-hover-js").next("ul").css("display") == "block") {
      const $navigation = $(".header__navigation").get(0);
      if (
        $navigation &&
        $navigation !== e.target &&
        !$.contains($navigation, e.target)
      ) {
        $(".dropdown-hover-js").next("ul").slideToggle("medium");
        $(".dropdown-hover-container")
          .find("button")
          .attr("aria-expanded", "false");
      }
    }
  });

  $("a:contains('Übersicht')").on("focus", function () {
    if ($(".dropdown-hover-js").next("ul").css("display") == "block") {
      $(".dropdown-hover-js").next("ul").slideToggle("medium");
      $(".dropdown-hover-container")
        .find("button")
        .attr("aria-expanded", "false");
    }
  });
});
